import { render, staticRenderFns } from "./agreement-rule.vue?vue&type=template&id=19495e88&scoped=true"
import script from "./agreement-rule.vue?vue&type=script&lang=js"
export * from "./agreement-rule.vue?vue&type=script&lang=js"
import style0 from "./agreement-rule.vue?vue&type=style&index=0&id=19495e88&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19495e88",
  null
  
)

export default component.exports